import { render, staticRenderFns } from "./IdentifierMapping.vue?vue&type=template&id=1ea726ca"
import script from "./IdentifierMapping.vue?vue&type=script&lang=js"
export * from "./IdentifierMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports